// extracted by mini-css-extract-plugin
export default {"slider_wrapper":"SliderBlock_slider_wrapper__smB+Z","separator":"SliderBlock_separator__NPno8"};